module.exports = __webpack_public_path__ + "static/media/fallback-category.c95e749d.webp";